import React, { useEffect, useState } from 'react';
import styles from './navbar.module.css';
import { useNavigate } from 'react-router-dom';
import { Avatar, Button, Divider, Menu, MenuItem, Typography } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { ArrowDown, LogoutIcon, Notification, Setting } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { setLogout } from '../../redux/userSlice';
import { getNotificationCount } from '../../redux/notification/notification';

const Navbar = ({ children }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [data, setData] = useState(null);
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.user);
  const {notificationCountData,isRefresh} = useSelector((state) => state.notification)

useEffect(() => {
   const fetchNotification = async() => {
    try {
      await  dispatch(getNotificationCount(user?.user?._id))
    } catch (error) {
        console.error("error occured",error)
    }
   }
   fetchNotification()
},[dispatch,user,isRefresh])


  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async () => {

    setAnchorEl(null);
  };
  const logout = async () => {
    await localStorage.clear()

    dispatch(setLogout())
    navigate('/')
  }
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className={styles.wrapper}>
      <div className={styles.headermenu}>
        <div>
          <p className={styles.welcome}>
            Welcome!
          </p>
        </div>
        <div>
          <div className={styles.menuStyle}>
            <div 
              onClick={() => navigate('/notifications')} 
              style={{ position: 'relative', marginRight: 18, marginTop: 5, cursor: 'pointer' }}
              title="View Notifications"
            >
              <Notification />
              <span className={styles.badge}>{notificationCountData || 0}</span>
            </div>
            <Divider orientation="vertical" flexItem sx={{ mx: 1, my: 1 }} />
            <div>
              <Button
                onClick={handleClick}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textTransform: 'none',
                }}
              >
                {user?.profileImg?.length > 0 ?
                
                  <div style={{ marginRight: '8px', width: '34px', height: '34px' }}>
                    <img src={user?.profileImg[0]} style={{ width: 30, height: 30 }} />
                  </div>
                  :
                  <Avatar sx={{ bgcolor: '#E0E0E0', color: '#000', marginRight: '8px', width: '34px', height: '34px' }}>
                    <img src='/assets/profile.png' />

                  </Avatar>
                }
                <div style={{ textAlign: 'left', marginRight: '12px' }}>
                  <Typography variant="body1" sx={{ color: '#07080B', fontSize: "14px" }}>{user?.name}</Typography>
                  <Typography variant="body2" sx={{ color: '#4A4C56', fontSize: "12px" }}>{user?.type}</Typography>
                </div>
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.30843 6.75H13.6874C13.8357 6.75003 13.9807 6.79404 14.104 6.87645C14.2273 6.95886 14.3234 7.07598 14.3802 7.21301C14.4369 7.35003 14.4518 7.50081 14.4229 7.64627C14.3939 7.79174 14.3225 7.92536 14.2177 8.03025L10.0282 12.2197C9.88754 12.3603 9.69681 12.4393 9.49793 12.4393C9.29906 12.4393 9.10833 12.3603 8.96768 12.2197L4.77818 8.03025C4.67333 7.92536 4.60192 7.79174 4.573 7.64627C4.54407 7.50081 4.55892 7.35003 4.61568 7.21301C4.67243 7.07598 4.76853 6.95886 4.89184 6.87645C5.01515 6.79404 5.16012 6.75003 5.30843 6.75Z" fill="#858D9D" />
                </svg>

              </Button>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={logout} sx={{ color: '#667085' }} >
                  <Logout fontSize="small" sx={{ marginRight: '8px' }} />
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Navbar